import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Store} from '@ngrx/store';
import {filter, take, tap} from 'rxjs/operators';
import { LicenseEntity } from '../entities/license.entity';
import { State } from '../State';
import { ResolverLoadLicenses } from '../State/actions/resolver.actions';

@Injectable({
    providedIn: 'root'
})
export class LicenseResolver implements Resolve<LicenseEntity[]> {
    constructor(private store: Store<State>) {
    }

    resolve() {
        const value$ = this.store.select(state => state.licenses.licenses);
        value$
            .pipe(
                filter(value => !value),
                take(1),
                tap(() => {
                    if (localStorage.getItem('token') != null) {
                        this.store.dispatch(new ResolverLoadLicenses());
                    }
                })
            )
            .subscribe();

        return value$.pipe(
            filter(value => !!value),
            take(1)
        );
    }
}
